import { render, staticRenderFns } from "./ModalStatisticsBlock.vue?vue&type=template&id=0f50647e"
import script from "./ModalStatisticsBlock.vue?vue&type=script&lang=js"
export * from "./ModalStatisticsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports